import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import Index from "./pages/Index";
import { performances } from "./data/performances";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

// Lazy load pages
const AttractionPage = lazy(() => import("./pages/attractions/[slug]"));
const RodoPage = lazy(() => import("./pages/RodoPage"));
const PrivacyPolicyPage = lazy(() => import("./pages/PrivacyPolicyPage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/rodo" element={<Suspense fallback={<LoadingSpinner />}><RodoPage /></Suspense>} />
          <Route path="/polityka-prywatnosci" element={<Suspense fallback={<LoadingSpinner />}><PrivacyPolicyPage /></Suspense>} />
          <Route path="/regulamin" element={<Suspense fallback={<LoadingSpinner />}><TermsPage /></Suspense>} />
          {performances.map((performance) => (
            <Route 
              key={performance.slug}
              path={`/atrakcje/${performance.slug}`}
              element={
                <Suspense fallback={<LoadingSpinner />}>
                  <AttractionPage slug={performance.slug} />
                </Suspense>
              }
            />
          ))}
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
